//import establishmentForm from '../mockEstablishmentData/mockEstablishmentForm';
import * as apiConstants from '../../constants/apiConstants';
import {createApiPath, createFetchAndCall} from '../fetch/fetchServices';

class retrieveFormsApi {
  static retrieveAllForms() {
    const formPaths = createApiPath(apiConstants.getFormsApi);
    const headers = {
      'Cache-Control': 'default'
    };
    const options = {
      method: "GET",
      headers: headers
    };
    return createFetchAndCall(formPaths, options);
  }

}

export default retrieveFormsApi;



/** WEBPACK FOOTER **
 ** ./src/api/forms/retrieveFormsApi.js
 **/